declare global {
  interface Window {
    pdfjsLib: any;
    $pdfjs: any;
  }
}

export default () => {
  // Wait for PDF.js to be loaded from CDN
  const initPdfjs = () => {
    const lib = (window as any).pdfjsLib;
    if (lib && lib.GlobalWorkerOptions) {
      lib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";
      (window as any).$pdfjs = lib;
      console.log('PDF.js initialized successfully');
    } else {
      // Retry after a short delay if not loaded yet
      setTimeout(initPdfjs, 3000);
    }
  };
  
  initPdfjs();
};
